import '../chunk-7P6ASYW6.mjs';

// constants/investments.ts
var DRAFT = "Draft";
var INVITE_SENT = "Invite Sent";
var ACCREDITATION_PENDING = "Accreditation Approval Pending";
var ACCREDITATION_SUBMITTED = "Accreditation Submitted";
var ACCREDITATION_APPROVED = "Accreditation Approved";
var ACCREDITATION_REJECTED = "Accreditation Rejected";
var ENTER_PASSWORD = "Enter Password";
var COMPLETE_PROFILE = "Complete Profile";
var DOCUMENT_REVIEW = "Document Review";
var DOCUMENTS_APPROVED = "Documents Approved";
var DOCUMENTS_REJECTED = "Documents Rejected";
var INVESTOR_PENDING = "Investor Pending";
var REVIEW_INVESTOR = "Review Investor";
var INVESTOR_APPROVED = "Investor Approved";
var INVESTOR_NAME_MISMATCH = "Investor Name Mismatch";
var INVESTOR_REJECTED = "Investor Rejected";
var ISSUER_REVIEW = "Issuer Review";
var ISSUER_APPROVED = "Issuer Approved";
var ISSUER_REJECTED = "Issuer Rejected";
var ISSUER_COUNTERSIGNED = "Issuer Countersigned";
var RECON_PENDING = "Recon Pending";
var AGREEMENT_PENDING = "Agreement Pending";
var AGREEMENT_SIGNED = "Agreement Signed";
var PAYMENT_PENDING = "Payment Pending";
var MANUAL_PAYMENT_PENDING = "Manual Payment Pending";
var REFUND_PENDING = "Refund Pending";
var PAYMENT_SUCCESSFUL = "Payment Successful";
var PAYMENT_PROCESSING = "Payment Processing";
var PAYMENT_FAILED = "Payment Failed";
var PAYMENT_REFUNDED = "Payment Refunded";
var SUBSCRIPTION_SUBMITTED = "Subscription Submitted";
var ACCEPTED = "Accepted";
var COMPLETED = "Completed";
var SERVICES_DISPLAY = {
  STRIPE: "Stripe",
  CRYPTO: "Crypto",
  DOCUSIGN: "DocuSign",
  DROPBOX_SIGN: "Dropbox Sign",
  DOCUSEAL: "DocuSeal",
  PLAID: "Plaid",
  PERSONA: "Persona",
  EQUIDEFI: "EquiDeFi",
  OPEN_API: "OpenAPI"
};
var MAX_ADDITIONAL_SIGNERS = {
  ENTITY: 3,
  JOINT: 1,
  TRUST: 3,
  INDIVIDUAL: 0
};
var INVESTMENT_STATUSES = ["PENDING", "REVIEW", "APPROVED", "COMPLETED", "CANCELED", "CLOSED"];
var INVESTMENT_STEPS = [
  "REGISTRATION",
  "PROFILE",
  "SUBSCRIPTION",
  "PAYMENT",
  "ADDRESS",
  "SIGNERS",
  "KYC",
  "AGREEMENT",
  "ACCREDITATION",
  "DILIGENCE",
  "COUNTERSIGN",
  "CLOSING"
];
var ENTITY = "ENTITY";
var INDIVIDUAL = "INDIVIDUAL";

export { ACCEPTED, ACCREDITATION_APPROVED, ACCREDITATION_PENDING, ACCREDITATION_REJECTED, ACCREDITATION_SUBMITTED, AGREEMENT_PENDING, AGREEMENT_SIGNED, COMPLETED, COMPLETE_PROFILE, DOCUMENTS_APPROVED, DOCUMENTS_REJECTED, DOCUMENT_REVIEW, DRAFT, ENTER_PASSWORD, ENTITY, INDIVIDUAL, INVESTMENT_STATUSES, INVESTMENT_STEPS, INVESTOR_APPROVED, INVESTOR_NAME_MISMATCH, INVESTOR_PENDING, INVESTOR_REJECTED, INVITE_SENT, ISSUER_APPROVED, ISSUER_COUNTERSIGNED, ISSUER_REJECTED, ISSUER_REVIEW, MANUAL_PAYMENT_PENDING, MAX_ADDITIONAL_SIGNERS, PAYMENT_FAILED, PAYMENT_PENDING, PAYMENT_PROCESSING, PAYMENT_REFUNDED, PAYMENT_SUCCESSFUL, RECON_PENDING, REFUND_PENDING, REVIEW_INVESTOR, SERVICES_DISPLAY, SUBSCRIPTION_SUBMITTED };
